import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { combineLatest, filter, map, take, tap } from 'rxjs';

import { UserService } from 'capiche-auth';
import { CapicheLoggerService } from 'capiche-logger';
import { CapicheSubscriptionService } from '../services/capiche-subscription.service';

export const redirectIfSubscribedGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const subscriptionService = inject(CapicheSubscriptionService);
  const logger = new CapicheLoggerService('redirect-if-subscribed.guard:', false);

  return combineLatest([userService.currentUser$, subscriptionService.hasActiveSubscription$]).pipe(
    tap(([user, hasSub]) => {
      logger.log('Evaluating – user:', user, 'sub:', hasSub);
    }),
    filter(([_, hasSub]) => hasSub !== null), // Only wait for subscription to resolve
    take(1),
    map(([user, hasSub]) => {
      if (!user) {
        logger.log('User not logged in – redirecting to /auth');
        return router.createUrlTree(['/auth']);
      }

      if (hasSub) {
        logger.log('User has subscription – redirecting to /app');
        return router.createUrlTree(['/app']);
      }

      logger.log('User logged in but not subscribed – allow access to /subscribe');
      return true;
    }),
  );
};
